export default __webpack_public_path__ + "static/media/EM1780.34I-43942_-26238_0.a7bf19b6.jpg";